<template>
  <div>
    <div>
      <mustache-template
        class="mb-3"
        label="field path"
        :value="selectedNode.settings.incomingPath"
        @input="(val) => onUpdate(val, 'settings.incomingPath')"
        :suggestions="availableInputFields"
        :singleLine="true"
      />
    </div>

    <div class="mb-3">
      <div class="text-subtitle-1 mb-2">Test Input (JSON)</div>
      <v-textarea
        v-model="testInputValue"
        @input="onTestInputChange"
        outlined
        label="Test JSON Input"
        placeholder="Enter test JSON input for testing the connector..."
        rows="8"
        :error-messages="jsonError"
        class="json-editor"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import MustacheTemplate from "@/components/mustache/mustache-template.vue";

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers("workflows/details");

export default {
  name: "incoming-general-settings",
  props: {
    availableInputFields: [],
  },
  components: {
    MustacheTemplate,
  },
  data() {
    return {
      testInputValue: "",
      jsonError: null,
    };
  },
  computed: {
    ...workflowDetailsGetters({
      selectedNode: "SELECTED_NODE",
    }),
    settings() {
      return this.selectedNode.settings;
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.initializeTestInput();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onUpdate(value, path) {
      this.$emit("update", value, path);
    },

    initializeTestInput() {
      if (this.selectedNode?.settings?.testInput) {
        try {
          this.testInputValue =
            typeof this.selectedNode.settings.testInput === 'string'
              ? this.selectedNode.settings.testInput
              : JSON.stringify(this.selectedNode.settings.testInput, null, 2);
        } catch (error) {
          this.testInputValue = "";
        }
      } else {
        this.testInputValue = "";
      }
      this.jsonError = null;
    },

    onTestInputChange(value) {
      this.validateAndUpdateJson(value);
    },

    validateAndUpdateJson(value) {
      if (!value || value.trim() === "") {
        this.jsonError = null;
        this.onUpdate(null, "settings.testInput");
        return;
      }

      try {
        const parsedJson = JSON.parse(value);
        this.jsonError = null;
        this.onUpdate(parsedJson, "settings.testInput");
      } catch (error) {
        let errorMessage = "Invalid JSON syntax: ";

        if (error.message.includes("Unexpected token")) {
          if (error.message.includes("Unexpected token }")) {
            errorMessage += 'Extra closing brace "}" - check for missing commas or quotes';
          } else if (error.message.includes("Unexpected token ]")) {
            errorMessage += 'Extra closing bracket "]" - check array structure';
          } else if (error.message.includes("Unexpected token ,")) {
            errorMessage += 'Extra comma "," - remove trailing commas';
          } else if (error.message.includes("Unexpected string")) {
            errorMessage += "Missing comma between properties or invalid quotes";
          } else {
            errorMessage += "Unexpected character - check quotes, commas, and brackets";
          }
        } else if (error.message.includes("Unexpected end")) {
          errorMessage += 'Incomplete JSON - missing closing brace "}" or bracket "]"';
        } else if (error.message.includes("Expected property name")) {
          errorMessage += 'Property names must be in double quotes "propertyName"';
        } else {
          errorMessage += error.message;
        }

        this.jsonError = errorMessage;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.json-editor {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}
</style>
